import { Directive, Input, OnInit } from '@angular/core'
import { MatFormField, MatFormFieldControl } from '@angular/material/form-field'

@Directive({
  selector: 'ng-content[linConnectControl], mat-form-field[linConnectControl]',
  standalone: false,
})
export class ConnectControlDirective implements OnInit {
  @Input() linConnectControl: MatFormFieldControl<any>

  constructor(private formField: MatFormField) {}

  ngOnInit() {
    this.formField._control = this.linConnectControl
  }
}
